import React, { useEffect, useState, useRef } from 'react';
import { navigate } from '@reach/router';
import { Typography } from "@material-ui/core";
import { Button, Cards } from 'ams-ui-reactkit';
import { TemplateProps } from '../../../journeys/journey/Interfaces';
import { Dialog, TitleBlock } from '../../../atoms';
import { StoreContext } from '../../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { getSignatureByIndex } from "./../../../common/GlobalUtils"
import useSiganture from "../DigitalSignature/useSiganture";
import { actionTypeConstants } from '../../../utils';
import { getRandomNumber } from '../../../utils/Utils';
import { AddSignatureBlock } from '../../../organisms';
import './TermsAndConditions.scss';

const TermsAndConditions: React.FC<TemplateProps> = (props: any) => {

    const [enableButton, setEnableButton] = useState(false);
    const dialogContentRef = useRef<any>(null);
    const [open, setPopup] = useState(false);
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const userReadTermsAndConditions: any = useContextSelector(StoreContext, store => (store?.appState?.ui as any)?.userReadTermsAndConditions);
    const AgreeCheck: any = signatures?.termsAndConditions?.agreeCheck;

    const signByInd = getSignatureByIndex(signatures?.list, 3);
    const [enableCheckbox, SetEnableCheckBox] = useState(AgreeCheck || false)

    let signUrl = signatures?.list?.find((s: any) => s.sequence === 1);
    const sign = signUrl?.getUrl || ""

    const [showSignature, setShowSignature] = useState(userReadTermsAndConditions || false);
    //pageNo will be used to hide/show Next, Back and Finish buttons in dialog foooter..
    const [pageNo, setPageNo] = useState(1);
    const { uploadSignature } = useSiganture();
    //As Action buttons are dynamic, actionIndex keep track of the current selected action item and its data like page content, title, no. of pages, etc
    const [actionIndex, setActionIndex] = useState(0);

    const { templateProps = {} } = props;

    const noOfPages = templateProps?.actions[actionIndex]?.pages.length;
    const popUpContent = templateProps?.actions[actionIndex]?.pages[pageNo - 1]?.content;
    const popUpHeader = templateProps?.actions[actionIndex]?.popUpHeader;

    useEffect(() => {
        dialogContentRef && dialogContentRef.current && dialogContentRef.current.scrollIntoView();
    }, [popUpContent])


    const handleClose = () => {
        setPopup(false);
    }

    const handleFinish = () => {
        setShowSignature(true);
        setPopup(false);
        dispatch({
            type: actionTypeConstants.USER_READ_TERMS_CONDITIONS,
            payload: {
                'userReadTermsAndConditions': true
            }
        })
    }

    const PopupBody = () => {

        return <div className="popupContentBlock" ref={dialogContentRef}>
            {popUpContent && <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} align="left" className="fw-400 color-light-grey">
                <div dangerouslySetInnerHTML={{ __html: popUpContent }} />
            </Typography>
            }
        </div >
    }
    const nextPage = () => setPageNo(pageNo + 1);

    const prevPage = () => setPageNo(pageNo - 1);

    const PopupFooter = () => {
        const justifyContentClass = pageNo > 1 ? "justify-content" : "";

        return <div className={`popupBtnsContainer ${justifyContentClass} `}>
            {pageNo < noOfPages && <Button
                text="NEXT"
                onClick={nextPage}
                color="primary"
                variant="outlined"
                endIcon="ChevronRight"
            />}
            {pageNo === noOfPages &&
                <Button
                    text="FINISH"
                    onClick={handleFinish}
                    color="primary"
                    variant="outlined"
                />}
            {pageNo > 1 &&
                <Button
                    text="BACK"
                    onClick={prevPage}
                    color="primary"
                    variant="outlined"
                    startIcon="ChevronLeft"
                />}

        </div>
    }

    const openPopup = (index = 0) => {
        setPopup(true);
        setActionIndex(index);
        setPageNo(1);
    }

    const ActionsRenderer = () => {

        const { actions = [] } = templateProps;

        return actions.map((item: any, pageIndex: number) => {
            const { btnText } = item;

            return <Button
                text={btnText}
                key={pageIndex + getRandomNumber()}
                onClick={() => openPopup(pageIndex)}
                color="primary"
                variant="contained"
                size="large"
            />;
        });

    }

    const handleSubmit = async () => {
        if (signByInd && !signByInd?.getUrl && signByInd?.putUrl) {
            uploadSignature(sign, signByInd)
        }

        navigate(templateProps?.nextScreen || '/')
    }


    useEffect(() => {
        (enableCheckbox) ? setEnableButton(true) : setEnableButton(false);
    }, [enableCheckbox])

    const handleSignClick = () => {
        SetEnableCheckBox(!enableCheckbox)
        dispatch({
            type: actionTypeConstants.TERMS_AND_CONDITIONS_ACCEPT_SIGN,
            payload: {
                status: !enableCheckbox
            }
        })
    }

    return (
        <div className="baseContainerBlock">
            <div className="tacContainer">
                <Cards variant='default'>
                    <div className="card-block-main">
                        {templateProps.title && <TitleBlock title={templateProps.title} />}

                        <div className="text">
                            <Typography variant='subtitle2' variantMapping={{ subtitle2: "div" }} className="color-light-grey fw-400" align="left">{templateProps?.subtitle}</Typography>
                        </div>

                        <Dialog title={popUpHeader}
                            open={open}
                            footer={PopupFooter()}
                            // asModel={true}
                            handleClose={handleClose}>
                            {PopupBody()}
                        </Dialog>

                        <div className={`actionBtnsContainer ${userReadTermsAndConditions ? 'inactive' : ''}`}>
                            {ActionsRenderer()}
                        </div>
                        {showSignature && <div className="mt-16">
                            <AddSignatureBlock signature={sign} enable={enableCheckbox} onClick={handleSignClick} />
                        </div>}
                    </div>
                </Cards>

                <div className="staticFixedButton">
                    <Button
                        text={templateProps?.button}
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                        size="large"
                        disabled={!enableButton}
                    />
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditions;
